import React, { useState, useEffect } from "react";
import style from "./style.module.scss";
import Row, { MobileCard } from "./row";
import AddMemberModal from "../../../../details/members/add-member-modal";
import RemoveMember from "../../../../details/members/delete-modal";
import SubOrgDetailPortal from "../sub-org-detail-portal";
import { useMediaQuery } from "../../../../../../hooks/useMediaQuery";

function SubOrgTable({ data = [], fetchSubOrgList, handleDeleteMember, updateMemberStatus, handleEditSubOrg }) {
  const tableData = Array.isArray(data) ? data : [];
  const isMobile = useMediaQuery(768);
  const [addMemberModalOpen, setAddMemberModalOpen] = useState(false);
  const [removeMemberModalOpen, setRemoveMemberModalOpen] = useState(false);
  const [selectedMemberData, setSelectedMemberData] = useState(null);
  const [selectedMember, setSelectedMember] = useState(null);
  const [selectedSubOrg, setSelectedSubOrg] = useState(null);
  const [selectedSubOrgIdForDetail, setSelectedSubOrgIdForDetail] = useState(null);

  const handleAddMember = (subOrgId) => {
    setSelectedMemberData(null);
    setAddMemberModalOpen(true);
    setSelectedSubOrg(subOrgId);
  };

  const handleRemoveMember = (subOrgId, id) => {
    setSelectedSubOrg(subOrgId);
    setSelectedMember(id);
    setRemoveMemberModalOpen(true);
  };

  const subOrgForPortal = selectedSubOrgIdForDetail
    ? tableData.find((r) => r?.id === selectedSubOrgIdForDetail) ?? null
    : null;


  return (
    <div className={style.batch_table_container}>
      <table className={style.batch_table}>
        <thead>
          <tr className={style.header_row}>
            <th className={style.header_cell}></th>
            <th className={style.header_cell}>Sub-Organization Name</th>
            <th className={style.header_cell}>MTD Processing Volume</th>
            <th className={style.header_cell}>Open Apps</th>
            <th className={style.header_cell}>CB Ratio</th>
            <th className={style.header_cell}>Non-Activated Accounts</th>
            <th className={style.header_cell}>APPROVALS (MON)	</th>           
            <th className={style.header_cell}>Members</th>
            <th className={style.header_cell}></th>
          </tr>
        </thead>
        <tbody>
        {tableData.length === 0 ? (
          <tr>
            <td colSpan="11" className={style.no_data}>
              <p>No sub-organizations to display</p>
            </td>
          </tr>
        ) : (
            tableData.map((row, index) => (
              <Row data={row} key={row?.id ?? index} handleAddMember={handleAddMember} handleRemoveMember={handleRemoveMember} updateMemberStatus={updateMemberStatus} handleEditSubOrg={handleEditSubOrg} />
            ))
          )}
        </tbody>
      </table>

      {isMobile && (
        <div className={style.mobile_cards_list}>
          {tableData.length === 0 ? (
            <div className={style.mobile_no_data}>
              <p>No sub-organizations to display</p>
            </div>
          ) : (
            tableData.map((row, index) => (
              <MobileCard
                key={row?.id ?? index}
                data={row}
                handleAddMember={handleAddMember}
                handleRemoveMember={handleRemoveMember}
                updateMemberStatus={updateMemberStatus}
                onOpenDetail={(subOrg) =>
                  setSelectedSubOrgIdForDetail(subOrg?.id ?? null)
                }
              />
            ))
          )}
        </div>
      )}
      {isMobile && subOrgForPortal && (
        <SubOrgDetailPortal
          subOrg={subOrgForPortal}
          onClose={() => setSelectedSubOrgIdForDetail(null)}
          onEditSubOrg={handleEditSubOrg}
          onAddMember={handleAddMember}
          onRemoveMember={handleRemoveMember}
          updateMemberStatus={updateMemberStatus}
        />
      )}
      {addMemberModalOpen && (
        <AddMemberModal
          open={addMemberModalOpen}
          onClose={() => {
            setAddMemberModalOpen(false);
            setSelectedMemberData(null);
            fetchSubOrgList(true);
          }}
          isEdit={selectedMemberData !== null}
          selectedMember={selectedMemberData}
          subOrgId={selectedSubOrg}
        />
      )}

      <RemoveMember
        open={removeMemberModalOpen}
        memberId={selectedMember}
        onClose={() => {
          handleDeleteMember(selectedSubOrg, selectedMember)
          setRemoveMemberModalOpen(false);
          setSelectedMember(null);
        }}
      />
    </div>
  );
}

export default SubOrgTable;
